import { gql } from '@apollo/client'

export const CREATE_TERRITORY_ANALYSIS_REPORT = gql`
  mutation CreateTerritoryAnalysisReport($data: CreateAutomaticJobTerritoryAnalysisInput!) {
    createAutomaticJobTerritoryAnalysis(data: $data) {
      ... on StatusMessage {
        success
        message
      }
      ... on WorkspaceJob {
        id
        isAutomaticallyGenerated
        workspaceId
      }
    }
  }
`

export const CREATE_CREATORS_SEARCH_REPORT = gql`
  mutation CreateAutomaticJobSearchCreators($data: CreateAutomaticJobSearchCreatorsInput!) {
    createAutomaticJobSearchCreators(data: $data) {
      ... on WorkspaceJob {
        id
        isAutomaticallyGenerated
        workspaceId
      }
      ... on StatusMessage {
        success
        message
      }
    }
  }
`

export const WINNIN_AI_REPORT_WALLET_QUERY = gql`
  query GenerateWinninAIReportUseCaseModal_WinninAIReportWallet {
    myWallet {
      amount
    }
  }
`
